/**
 * Card container component with StyleX styling.
 */
import * as stylex from "@stylexjs/stylex";

import { colors, radius, space } from "../tokens.stylex";

const styles = stylex.create({
  base: {
    width: "100%",
    maxWidth: 448,
    borderRadius: radius.lg,
    backgroundColor: colors.card,
    padding: space["2xl"],
  },
  bordered: {
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: colors.border,
  },
});

// Export styles for direct use with stylex.props()
export const card = styles;

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  bordered?: boolean;
  xstyle?: stylex.StyleXStyles;
}

function Card({ bordered, xstyle, ...props }: CardProps) {
  return (
    <div
      {...stylex.props(styles.base, bordered && styles.bordered, xstyle)}
      {...props}
    />
  );
}

export { Card, type CardProps };
